module.exports = __webpack_public_path__ + "img/hallType1.cc9dd9a9.png";